import { apiClient } from '@/api/apiClient';
import endpoints from './endpoints';

export default {
  getByAgencyId: async ({ agency_id, ...params }) =>
    await apiClient.get(endpoints.getByAgencyId(agency_id), { params }),
  createIdentifier: async (params) => await apiClient.post(endpoints.create(params.agency_id), params),
  updateIdentifier: async ({ agency_id, identifier_id, ...params }) =>
    await apiClient.put(endpoints.update(agency_id, identifier_id), params),
  getAgencyIdentifiers: async (params) => await apiClient.get(endpoints.getAgencyIdentifiers(), { params }),
  previewIdentifier: async (params) => await apiClient.post(endpoints.previewIdentifier(), params),
};
